import axios from 'axios'
import router from '../../router'

const actions = {
  apiInformantSignin (context, payload) {
    axios.post('/api/informant/signin', payload)
      .then((response) => {
        sessionStorage.setItem('token', 'Bearer ' + response.data.token)
        sessionStorage.setItem('timestamp', payload.timestamp)
        router.push('/inquirypage')
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiAdminSignin (context, payload) {
    axios.post('/api/admin/signin', payload)
      .then((response) => {
        sessionStorage.setItem('token', 'Bearer ' + response.data.token)
        sessionStorage.setItem('timestamp', payload.timestamp)
        if (sessionStorage.getItem('token') != null) {
          axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
          axios.get('/api/admin/GroupMenus')
            .then((response) => {
              router.push(response.data[0].url)
            })
            .catch((error) => {
              alert(error.response.data.message)
              if (error.response.status === 410) {
                sessionStorage.removeItem('token')
                router.push('/sessiontimeout')
              }
            })
        } else {
          router.push('/sessiontimeout')
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/signin.js